<div class="record-actions">
  <div class="record-actions-header">
    <ng-container> {{ order + 1 }}.</ng-container>
    <ng-container *ngIf="isChina" class="buttons">
      <a class="action-element"
        ><mat-icon
          class="handle print-hidden"
          color="y-icon"
          svgIcon="alt-handle-icon"
          color=""
          cdkDragHandle
        ></mat-icon
      ></a>
      <mat-icon
        class="green-close print-hidden"
        color="y-icon"
        svgIcon="close-icon-grey"
        (click)="removeRecord.emit(order)"
      ></mat-icon>
      <a (click)="goToRecordDetails()" class="action-element">
        <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
      </a>
    </ng-container>
  </div>
  <div
    class="image-border"
    miq-bg-image
    [secureImage]="
      record | reportFieldFormatter: { templateId: currentView.templateId, field: imageField, joinString: true } | async
    "
  ></div>
</div>
<div class="body-group-dropdown" *ngIf="showGroup">
  <div>
    <span class="group-name" l10nTranslate>reports.groupName</span>
  </div>

  <mat-form-field appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      matNativeControl
      [(ngModel)]="selectedValue"
      (selectionChange)="selectionChanged()"
      autocomplete="no-autofill"
    >
      <mat-option [value]="0" l10nTranslate>reports.none</mat-option>
      <mat-option
        *ngFor="let group of recordLevelGroups; let i = index"
        [value]="group.groupID"
        [disabled]="group.isDisabled"
      >
        {{ group.groupName }}
      </mat-option>
      <mat-option [value]="-1" l10nTranslate>reports.addNewGroup</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="compare-body">
  <ul>
    <li *ngIf="confidentialityTmpl">
      <ng-container
        *ngTemplateOutlet="confidentialityTmpl; context: { reportItem: record, displayLabel: true, isDataOnly: true }"
      ></ng-container>
    </li>
  </ul>
  <div *ngFor="let field of allDataFields; let index = index">
    <div
      class="label"
      [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
      (click)="emitEditableFields($event, field.id)"
    >
      {{
        record | reportFieldFormatter: { templateId: currentView.templateId, field: field, joinString: true } | async
      }}
    </div>
  </div>
</div>
